import { render, staticRenderFns } from "./student-motivation.vue?vue&type=template&id=5cd16425&scoped=true&"
import script from "./student-motivation.vue?vue&type=script&lang=js&"
export * from "./student-motivation.vue?vue&type=script&lang=js&"
import style0 from "./student-motivation.vue?vue&type=style&index=0&id=5cd16425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd16425",
  null
  
)

export default component.exports